import React, { FC, ReactNode } from 'react';
import { Visible as OrginalVisible } from 'react-grid-system';

export interface VisibleProps {
  /** Content to display. */
  children: ReactNode;
  /** The breakpoints on which to show the content. */
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
}

/**
 * @since 0.24.0
 * @component
 * @mode developer
 */
const Visible: FC<VisibleProps> = (props) => <OrginalVisible {...props} />;

export default Visible;
